<template>
	<div class="header">
		<div class="anchor">
			<div class="bar">
				<div class="left">
					<div class="menu-button">
						<button @click="bShowSideNav = !bShowSideNav"><div class="fas fa-bars fa-fw"></div></button>
					</div>
				
					<div class="logo">
						<router-link class="image-link" :to="{name: 'home', hash: '#home'}">
							<img :src="require('@/assets/logo_long.png')" height="40" style="margin-top:5px;"/>
						</router-link>
					</div>
				

					<div class="nav">
						<a class="link t-uppercase" href="/#services">servizi</a>
						<a class="link t-uppercase" href="/#why">perchè sceglierci?</a>
						<a class="link t-uppercase" href="/#gym">la palestra</a>
						<a class="link t-uppercase" href="/#about">chi siamo</a>
						<a class="link t-uppercase" href="/#blog">blog</a>
						<a class="link t-uppercase" href="/#contacts">contatti</a>
						<a class="link t-uppercase" href="/#trial">prova gratuita</a>
						<!--<router-link class="link t-uppercase" to="/eximus-online-training">Eximus Online Training</router-link>-->
						<a class="link t-uppercase" href="/#ebook">ebook & schede gratis</a>
						<a class="link t-uppercase" href="/analisicorsa" style="color: #ffe010;">analisi corsa</a>
					</div>
				</div>

				<div class="middle">
					<div class="logo">
						<router-link class="image-link" :to="{name: 'home', hash: '#home'}">
							<img :src="require('@/assets/logo_long.png')" height="36"/>
						</router-link>
					</div>
				</div>

				<div class="right">
					<div class="user-menu" v-if="user" @mouseleave="bShowUserMenu = false" @click="bShowUserMenu = !bShowUserMenu">
						<div class="button">
							<div class="icon-md c-primary">arrow_drop_down</div>
							<UserPicture class="image" :src="user.picture_url"/>
						</div>

						<transition name="fade-down">
							<ContextMenu class="menu" :options="userMenuOptions" v-if="bShowUserMenu"/>
						</transition>
					</div>
					<div class="nav" v-else>
						<router-link class="link" to="../login">
							<span class="icon-md t-middle" style="margin-right: 0.2em;">person</span>
							
						</router-link>
					</div>
				</div>
			</div>
		</div>

		<transition name="fade-right">
			<div class="overlay" v-if="bShowSideNav" @click="bShowSideNav = false"></div>
		</transition>

		<div class="side" :class="{'show': bShowSideNav}" @click="bShowSideNav = false">
			<div class="side-nav">
				<a class="link t-uppercase" href="/#services">servizi</a>
				<a class="link t-uppercase" href="/#why">perchè sceglierci?</a>
				<a class="link t-uppercase" href="/#gym">la palestra</a>
				<a class="link t-uppercase" href="/#about">chi siamo</a>
				<a class="link t-uppercase" href="/#blog">blog</a>
				<a class="link t-uppercase" href="/#contacts">contatti</a>
				<a class="link t-uppercase" href="/#trial">prova gratuita</a>
				<!--<router-link class="link t-uppercase" to="/eximus-online-training">Eximus Online Training</router-link>-->
				<a class="link t-uppercase" href="/#ebook">ebook & schede gratis</a>
				<a class="link t-uppercase" href="/analisicorsa" style="color: #ffe010;">analisi corsa</a>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	name: 'header-bar',

	data() {

		return {
			// Show user menu flag
			bShowUserMenu: false,

			// Show side navigation
			bShowSideNav: false
		}
	},

	computed: {
		/**
		 * Store getters
		 */
		...mapGetters({
			user: 'auth/user'
		}),

		/**
		 * Computed user menu options
		 */
		userMenuOptions() {

			return {
				// Dashboard
				'Area riservata': {
					link: {name: 'dashboard'},
					icon: 'fas fa-th'
				},

				// EOT
				
				// Logout
				'Log out': {
					action: () => {

						console.log(this)
						this.$store.dispatch('auth/logout')
						this.$router.push({name: 'home'})
					},
					icon: 'fas fa-sign-out-alt'
				}
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
barHeight = 4em

.header:before
	content ''

	height barHeight
	display block

.anchor
	width 100%

	position fixed
	top 0
	left 0
	z-index 999

.bar
	height barHeight
	
	//background-image linear-gradient(dark, rgba(dark, 0.0))
	background-color darker

	.left
		height 100%

		display flex
		justify-content left
		align-items center

		float left
	
		.logo
			height 100%

			display flex
			align-items center

			padding 0.3em 0.6em

			color light

			font-size 1.6em
			font-weight bold

			.image-link
				display block

				color inherit

				text-decoration none
		
		.menu-button
			height 100%

			>button
				height 100%

				display flex
				align-items center

				border none

				background-color transparent
				color primary

				font-size 2em

				&:focus
					outline none
				&:hover
					background-color mix(darkish, dark)
	
		@media (max-width: unit(1591, px))
			.logo
			.nav
				display none
		
		@media (min-width: unit(1592, px))
			.menu-button
				display none
		
	.nav
		height 100%

		display flex
		justify-content center
		align-items center

		.link
			height 100%

			display flex
			justify-content center
			align-items center

			border-top 0px solid transparent
			border-bottom 0px solid transparent
			padding 0.4em 0.8em
			box-sizing border-box

			color light

			font-size 1.1em
			font-weight bold

			text-decoration none

			transition 0.18s ease

			@media (max-width: unit(1591, px))
				padding 0.4em 0.6em

			&:hover
				border-top 4px solid transparent
				border-bottom 4px solid primary
	
	.middle
		position absolute
		left 50%
		top 50%

		transform translate(-50%, -50%)
		
		@media (min-width: unit(1592, px))
			display none
	
	.right
		height 100%

		display flex
		justify-content right
		align-items center

		float right

		.user-menu
			height 100%

			position relative

			.button
				height 100%

				display flex
				align-items center

				cursor pointer

				font-size 1.4em

				&:hover
					background-color mix(dark, darkish, 60%)

				.image
					width 2em
					height 2em

					margin auto 0.2em
			
			.menu
				position absolute
				top 100%
				right 0

				margin-top -2.1em

				&:before
					content ''

					height 2em

					display block

					position relative

					background-color transparent

		.login
			padding 0.2em 0.6em

			color light

.overlay
	height 100%
	width 100%

	position fixed
	top 0
	left 0
	z-index 998

	background-color rgba(darker, 0.5)

.side
	height calc(100% - 4em)
	max-width 320px

	position fixed
	top 0
	left 0
	z-index 999

	margin-top 4em

	background-color mix(darkish, dark)

	transform translateX(-100%)

	transition 0.15s ease

	&.show
		transform translateX(0)

	.side-nav
		.link
			display block

			padding 0.6em 1em
			border-left 0.2em solid transparent
			border-right 0.2em solid transparent

			color light

			font-family fontSans
			font-size 1.2em
			font-weight bold

			text-decoration none
			text-transform uppercase

			transition 0.2s ease

			&.router-link-exact-active
				border-right 0.2em solid primary

@media (min-width: unit(1592, px))
	.overlay
	.side
		display none
</style>